import { EFinancingProgram, ELanguage, ELoanPurpose } from '@if/core/types'
import { InvitationResultDto } from '@src/types/InvitationResultDto'
import { ECommunicationType } from '@src/types/InvitationSchema'
import { MutationFunction, useMutation } from '@tanstack/react-query'
import { getApiClient } from '../api-client'

export interface InvitationDto {
  firstName: string
  lastName: string
  languageId: ELanguage
  communicationType: ECommunicationType
  email: string | null
  mobilePhoneNumber: string | null
  financingProgramId: EFinancingProgram
  loanPurposeId?: ELoanPurpose | null
}

const sendInvitation: MutationFunction<InvitationResultDto, InvitationDto> = async (dto: InvitationDto) => {
  const apiClient = getApiClient()
  const response = await apiClient.post('/Invitation/Send', dto)
  return response.data as InvitationResultDto
}

export function useSendInvitation(): [MutationFunction<InvitationResultDto, InvitationDto>, boolean, boolean, () => void] {
  const { mutateAsync, isPending, isError, reset } = useMutation({
    mutationFn: sendInvitation,
    onSuccess: (data) => {
      return data
    },
  })

  return [mutateAsync, isPending, isError, reset]
}

export async function sendApplicationInvitation(invitation: InvitationDto): Promise<InvitationResultDto> {
  const apiClient = getApiClient()
  const response = await apiClient.post('/Invitation/Send', invitation)
  return response.data as InvitationResultDto
}
